import { createInstance, setLogger } from '@optimizely/optimizely-sdk';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import captureSentryException from '../tracking/sentry/captureSentryException';
import store from '../store';
import updateDataAnalyticsLayer from '../tracking/adobe/updateDataAnalyticsLayer';

// Optimizely Full Stack
const sentryErrorHandler = {
  handleError(error) {
    captureSentryException(error);
  },
};

// eslint-disable-next-line import/no-mutable-exports
let optimizelyInstanceInner;
let userId;

if (process.env.OPTIMIZELY_SDK_KEY && !optimizelyInstanceInner) {
  if (process.env.OPTIMIZELY_COOKIE_USER_ID) {
    userId = Cookies.get(process.env.OPTIMIZELY_COOKIE_USER_ID);
  }

  optimizelyInstanceInner = createInstance({
    sdkKey:             process.env.OPTIMIZELY_SDK_KEY,
    eventBatchSize:     10,
    eventFlushInterval: 1000,
    errorHandler:       sentryErrorHandler,
  });

  setLogger(null);
}

export const optimizelyInstance = optimizelyInstanceInner;

export function optimizelyUserId() {
  if (!userId) {
    userId = uuidv4();
  }

  return userId;
}

export function trackEvent(event, id, attributes = {}) {
  // eslint-disable-next-line no-param-reassign
  attributes.visitor_id = store.get('rails_session_id');

  if (attributes.environment === undefined) {
    // eslint-disable-next-line no-param-reassign
    attributes.environment = process.env.NODE_ENV;
  }

  optimizelyInstance.track(event.toString(), id.toString(), attributes);
}

export function isFeatureEnabled(feature, id) {
  return optimizelyInstance.isFeatureEnabled(feature.toString(), id.toString());
}

export function activate(feature, id, attributes = {}) {
  return optimizelyInstance.activate(feature.toString(), id.toString(), attributes);
}

export async function optimizelyUserContext(incomeSource) {
  let customerType = 'existing';

  // eslint-disable-next-line no-undef
  if (typeof analyticsDataLayer === 'undefined' || typeof analyticsDataLayer.customerType === 'undefined') {
    await updateDataAnalyticsLayer();
  }

  // eslint-disable-next-line no-undef
  if (typeof analyticsDataLayer !== 'undefined') {
    // eslint-disable-next-line no-undef
    if (!analyticsDataLayer.customerType.includes('Existing')) {
      customerType = 'new';
    }

    const account = await store.get('account');
    if (account.preapproval_campaign_id) {
      customerType = 'pre-approved';
    }
  }

  return {
    environment:   process.env.NODE_ENV,
    customer_type: customerType,
    income_source: incomeSource,
  };
}
